import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import { Link } from 'gatsby';

const AnchorStyled = styled.div`
    &.button {
        & > a {
            padding: 15px 20px;
            font-weight: bold;
            font-size: 12px;
            font-family: ${(props) => props.theme.fonts[0]}, sans-serif;
            text-transform: uppercase;
            cursor: pointer;
            letter-spacing: 2.24px;
            border-radius: 2px;
        }
        &--secondary {
            & > a {
                color: #fff;
                background-color: ${(props) =>
                    props.theme.colors.buttons.primary};
                &:hover {
                    background-color: ${(props) =>
                        props.theme.colors.buttons.primaryHover};
                }
                @media screen and (min-width: 768px) {
                    margin-left: 80px;
                }
            }
        }
    }

    & > a {
        position: relative;
        text-decoration: none;
        font-family: ${(props) => props.theme.fonts[0]}, sans-serif;
        .subMenu--Links& {
            font-size: 0.875rem;
            font-weight: 500;
        }
        .header__nav--links& {
            font-size: 0.75rem;
            font-weight: bold;
        }
        .header__nav--links&,
        .subMenu--Links& {
            color: ${(props) => props.theme.colors.white};
            border: none;
            text-transform: uppercase;
            cursor: pointer;
            letter-spacing: 2.24px;
            padding: 0 0 10px 0;
            .menu--solid &,
            .subMenu--Links& {
                color: ${(props) => props.theme.colors.texts.shipGrey};
                .subMenu__holder & {
                    letter-spacing: 2.62px;
                }
            }
            @media screen and (min-width: 768px) {
                .subMenu--Links.active& {
                    color: ${(props) => props.theme.colors.secondary};
                }
            }

            &:after {
                content: '';
                position: absolute;
                width: 0%;
                height: 2px;
                background: transparent;
                bottom: 0;
                left: 0;
                transition: all 0.3s linear;
            }
        }
    }

    &.header__nav--links:hover,
    &.header__nav--links.active {
        & a {
            &:after {
                width: 100%;
                background: ${(props) => props.theme.colors.primary};
            }
        }
    }
`;

export default function Anchor({
    clickEvent,
    linkURL,
    text,
    className,
    isExternal,
}) {
    return (
        <AnchorStyled className={className}>
            {!isExternal ? (
                <Link to={linkURL} onClick={clickEvent}>
                    {' '}
                    {text}{' '}
                </Link>
            ) : (
                <a href={linkURL} onClick={clickEvent}>
                    {text}
                </a>
            )}
        </AnchorStyled>
    );
}

Anchor.propTypes = {
    clickEvent: PropTypes.func,
    linkURL: PropTypes.string,
    text: PropTypes.string.isRequired,
    className: PropTypes.string,
    isExternal: PropTypes.bool,
};

Anchor.defaultProps = {
    linkURL: '',
    isExternal: false,
};
